import { createRootRoute, HeadContent, Outlet } from '@tanstack/react-router'
import { SiteFooter } from '@/components/SiteFooter'
import { SiteHeader } from '@/components/SiteHeader'

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  return (
    <>
      <HeadContent />
      <div className="marketing-app d-flex flex-column min-vh-100 bg-body text-body">
      <a
        href="#main-content"
        className="visually-hidden-focusable btn btn-sm btn-outline-secondary position-fixed top-0 start-0 m-2 z-3"
      >
        Skip to Content
      </a>
      <SiteHeader />
      <main id="main-content" className="flex-grow-1" tabIndex={-1}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
    </>
  )
}
